<template>
  <div class="modal fade">
    <v-dialog :value="value" @input="$emit('input')" width="400">
      <v-layout>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense class="elevation-2">
              <v-spacer></v-spacer>
              <v-toolbar-title>Change Password</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon @click="closeModal">close</v-icon>
              </v-btn>
            </v-toolbar>
          <v-card-text>
            <!-- Alert error message -->
            <div class="col-md-12">
              <b-alert :show="errorMessage !== null" dismissible variant="danger">
                <p>{{errorMessage}}</p>
              </b-alert>
            </div>
            <!-- Alert error message -->
            <form>
              <v-container class="remove-padding" container--fluid>
                <v-layout row wrap>
                  <v-flex xs12 sm12>
                    <v-text-field
                      v-model="user.oldPassword"
                      @input="$v.user.oldPassword.$touch()"
                      @blur="$v.user.oldPassword.$touch()"
                      :append-icon="show.oldPassword ? 'visibility_off' : 'visibility'"
                      :type="show.oldPassword ? 'text' : 'password'"
                      :error-messages="currentPasswordErrors"
                      autocomplete="current-password"
                      name="current-password"
                      label="Current Password"
                      @click:append="show.oldPassword = !show.oldPassword"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12>
                    <v-text-field
                      v-model="user.newPassword"
                      @input="$v.user.newPassword.$touch()"
                      @blur="$v.user.newPassword.$touch()"
                      :error-messages="passwordError"
                      :append-icon="show.password ? 'visibility_off' : 'visibility'"
                      :type="show.password ? 'text' : 'password'"
                      autocomplete="new-password"
                      name="new-password"
                      color="#1687c0"
                      label="New Password"
                      class="input-group--focused"
                      @click:append="show.password = !show.password"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12>
                    <v-text-field
                      v-model="user.repeatPassword"
                      @input="$v.user.repeatPassword.$touch()"
                      @blur="$v.user.repeatPassword.$touch()"
                      :append-icon="show.repeatPassword ? 'visibility_off' : 'visibility'"
                      :type="show.repeatPassword ? 'text' : 'password'"
                      :error-messages="repeatPasswordErrors"
                      name="repeat-password"
                      autocomplete="new-password"
                      label="Repeat Password"
                      class="input-group--focused"
                      @click:append="show.repeatPassword = !show.repeatPassword"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </form>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="closeModal">Close</v-btn>
            <v-spacer></v-spacer>
            <v-btn text
              color="secondary"
              :disabled="$v.user.$invalid"
              @click="changePassword"
            >Change Password</v-btn>
          </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
  </div>
</template>
<script>
import userAPIs from './userAPIs';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import { regex } from 'vuelidate/lib/validators/common';
import config from '../../../config';
// check validity of password (containing lowers, uppers, symbols, number)
const lowers = regex('lowers', config.regexPattern.lowers); // lowercase
const uppers = regex('uppers', config.regexPattern.uppers); // uppercase
const numbers = regex('numbers', config.regexPattern.numbers); // number (0-9)
const symbols = regex('numbers', config.regexPattern.symbols); // scontain 1 non-alpha numeric number

export default {
  name: 'ChangePasswordModal',
  props: {
    value: Boolean
  },
  data() {
    return {
      user: {},
      errorMessage: null,
      show: {
        oldPassword: false,
        password: false,
        repeatPassword: false
      }
    };
  },
  watch: {
    // userData: function (newUserData) {
    //   this.user = newUserData
    // }
  },

  computed: {
    passwordError() {
      const errors = [];
      if (!this.$v.user.newPassword.$dirty) return errors;
      !this.$v.user.newPassword.required && errors.push('Password is required.');
      !this.$v.user.newPassword.uppers && errors.push('Password must contain upper letter.');
      !this.$v.user.newPassword.lowers && errors.push('Password must contain lower letters.');
      !this.$v.user.newPassword.numbers && errors.push('Password must contain numbers.');
      !this.$v.user.newPassword.symbols && errors.push('Password must contain non-alpha letters.');
      !this.$v.user.newPassword.minLength && errors.push('Password must be at least 8 characters.');
      return errors;
    },

    currentPasswordErrors() {
      const errors = [];
      if (!this.$v.user.oldPassword.$dirty) return errors;
      !this.$v.user.oldPassword.required && errors.push('Old Password is required.');
      return errors;
    },

    repeatPasswordErrors() {
      const errors = [];
      if (!this.$v.user.repeatPassword.$dirty) return errors;
      !this.$v.user.repeatPassword.sameAsPassword && errors.push("Password doesn't match.");
      return errors;
    }
  },

  validations: {
    user: {
      oldPassword: {
        required
      },
      newPassword: {
        required,
        minLength: minLength(8),
        uppers,
        lowers,
        numbers,
        symbols
      },
      repeatPassword: {
        sameAsPassword: sameAs('newPassword')
      }
    }
  },
  methods: {
    closeModal: function() {
      this.$emit('input')
    },
    changePassword: function() {
      this.errorMessage = null;
      const editingInfo = {
        id: this.$store.state.user.id,
        oldPassword: this.user.oldPassword,
        newPassword: this.user.newPassword
      };
      // Change password
      userAPIs
        .changePassword(editingInfo)
        .then(response => {
          // Return the newly added data to parent component
          this.$emit('changePassword', response);
          // Dismiss modal by triggering the click event on Close button
          this.$refs.closeButton.click();
        })
        .catch(error => {
          // Request failed.
          this.errorMessage = error.response.data.message;
          console.log('error.response', error.response);
          console.log('error.response.data', error.response.data);
          console.log('error', error.response.data.message);
        });
    },
    clearData: function() {
      this.user = {
        newPassword: '',
        oldPassword: '',
        repeatPassword: ''
      };
    }
  },
  mounted: function() {
    this.user = {
      newPassword: '',
      oldPassword: '',
      repeatPassword: ''
    };
  }
};
</script>

<style>
.password-errors {
  display: block;
  margin-top: 1em;
  margin-bottom: 1 em;
  margin-left: 0;
  margin-right: 0;
  padding-left: 40px;
}
.primary--text {
  color: #1687c0 !important;
  caret-color: #1687c0 !important;
}

.modal-body {
  padding: 0px 25px !important;
}

.remove-padding {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.error--text {
  color: #d65849c7 !important;
  caret-color: #d65849c7 !important;
}
/* .v-messages__wrapper {
  color: #1687c0
} */
ul > li {
  list-style-type: square;
}
li.error-message {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// ChangePasswordModal.vue?76a1eaef